"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _priceSetting = require("@/api/priceSetting");
var _goodPrice = _interopRequireDefault(require("../component/goodPrice"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  // name: "index"
  components: {
    goodPrice: _goodPrice.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listData: {
        list: []
      },
      listPram: {
        adjustmentNo: undefined,
        adjustReason: undefined,
        adjustTime: undefined,
        applyMethod: undefined,
        auditStatus: '0',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      menuList: [],
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0 = 创建，1=编辑  2 = 详情
        editData: {},
        title: ''
      },
      selectedRows: [],
      auditDialogVisible: false,
      auditForm: {
        adjustmentIds: [],
        auditStatus: '2',
        approveRemark: ''
      }
    };
  },
  mounted: function mounted() {
    this.handleGetList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handlerAudit: function handlerAudit(row) {
      this.auditDialogVisible = true;
      this.auditForm.adjustmentIds = [row.id];
      this.auditForm.auditStatus = '2';
      this.auditForm.approveRemark = '';
    },
    closeAuditDialog: function closeAuditDialog() {
      this.auditDialogVisible = false;
      this.auditForm = {
        adjustmentIds: [],
        auditStatus: '2',
        approveRemark: ''
      };
    },
    allAudio: function allAudio() {
      this.auditDialogVisible = true;
      this.auditForm.adjustmentIds = this.selectedRows.map(function (item) {
        return item.id;
      });
      this.auditForm.auditStatus = '2';
      this.auditForm.approveRemark = '';
    },
    approveHandle: function approveHandle(data) {
      this.auditDialogVisible = true;
      this.auditForm = {
        adjustmentIds: [data],
        auditStatus: '2',
        approveRemark: ''
      };
    },
    handlerAuditSubmit: (0, _validate.Debounce)(function () {
      var _this = this;
      (0, _priceSetting.adjustPriceApprove)(this.auditForm).then(function (data) {
        _this.$message.success('操作成功');
        _this.handleGetList();
        _this.closeAuditDialog();
        _this.editDialogConfig.visible = false;
      });
    }),
    handleSelectionChange: function handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    handleGetList: function handleGetList() {
      var _this2 = this;
      var formData = _objectSpread({}, this.listPram);
      if (formData.adjustTime && formData.adjustTime.length > 0) {
        formData.applyTimeStart = formData.adjustTime[0];
        formData.applyTimeEnd = formData.adjustTime[1];
        delete formData.adjustTime;
      }
      (0, _priceSetting.adjustPriceList)(formData).then(function (data) {
        _this2.listData = data;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(isCreate, editDate) {
      isCreate !== 0 ? this.editDialogConfig.editData = editDate : this.editDialogConfig.editData = {};
      this.editDialogConfig.isCreate = isCreate;
      this.editDialogConfig.visible = true;
      if (isCreate === 0) {
        this.editDialogConfig.title = '创建价格监控调价单';
      }
      if (isCreate === 1) {
        this.editDialogConfig.title = '编辑价格监控调价单';
      }
      if (isCreate === 2) {
        this.editDialogConfig.title = '调价详情';
      }
    },
    hideEditDialog: function hideEditDialog() {
      this.editDialogConfig.visible = false;
      this.handleGetList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleGetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleGetList(this.listPram);
    },
    //修改状态
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      baseConfigAip.updateRoleStatus(row).then(function (res) {
        _this3.$message.success('更新状态成功');
        _this3.handleGetList();
      });
    },
    resetQuery: function resetQuery() {
      this.listPram = {
        createTime: null,
        updateTime: null,
        level: null,
        page: 1,
        limit: this.$constants.page.limit[0],
        roleName: null,
        rules: null,
        status: null
      };
      this.handleGetList();
    }
  }
};